// extracted by mini-css-extract-plugin
export default {"button":"Kn-z","reviewSort":"Ln-z"};